<unity-page-container
  [contentHeader]="$contentHeader()"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [isLoading]="$agreementResourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Submit" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-textbox-control
      displayName="Name"
      description="Specify a name for the form. such as 'Monthly Report'."
      [control]="formGroup.controls.name" />

    <unity-textarea-control
      displayName="Description"
      description="Provide a brief summary of the form's purpose and usage."
      [control]="formGroup.controls.description" />

    <unity-radio-confirmation-control
      displayName="Will this form only need to be filled out once?"
      description="Choose 'Yes' if this form is tied to a single event or due date and won't be reused."
      [control]="formGroup.controls.is_one_time" />

    @if ($showRecurringQuestion() === true) {
      <unity-radio-confirmation-control
        displayName="Do you want this form to be completed on a regular schedule?"
        description="Select 'Yes' if the form should be completed on a repeating schedule, like weekly or monthly."
        [control]="formGroup.controls.is_recurring" />
    }

    @if ($showStartDate() === true) {
      @let startDateLabel = $startDateLabel();
      @let startDateDescription = $startDateDescription();
      <unity-selector-date-control
        [control]="formGroup.controls.start_date"
        [displayName]="startDateLabel"
        [description]="startDateDescription" />
    }

    @if ($showScheduler() === true) {
      <unity-selector-recurrence-control [control]="formGroup.controls.recurrence_rule" />
    }

    @if ($showDaysVisibleBeforeOpen() === true) {
      <unity-textbox-numeric-integer-control
        displayName="How many days before the due date should the form open?"
        description="Specifies how many days in advance users can access the form before the due date."
        [control]="formGroup.controls.days_visible_before_open!" />
    }

    @if ($showFormCreator() === true) {
      <unity-dropdown-form-schemas-control
        displayName="Form Schema"
        description="Select a form schema to use for this schedule."
        [control]="formGroup.controls.form_schema_id"
        [selectable]="$formSchemas()" />
    }
  </unity-card-new-shared>
</unity-page-container>
